import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'
import { arrayDifference, uniqueArray } from '@SonarCX/utilities'

//- is for desc
type AllTasksTableState = {
  sort: Array<'' | string>
  customSort: Array<'' | string>
  tableApiSort: Array<TableApiSort>
  pagination: IndexPagination
  selected: Array<string>
}

const initialPagination: IndexPagination = {
  page: 0,
  per_page: 25,
  total: 0
}

const initialState: AllTasksTableState = {
  sort: [],
  customSort: [],
  tableApiSort: [],
  selected: [],
  pagination: initialPagination
}

export const allTasksTable = createSlice({
  name: 'allTasksTable',
  initialState: initialState,
  reducers: {
    setPagination: (
      state: AllTasksTableState,
      { payload }: PayloadAction<IndexPagination>
    ) => {
      state.pagination = payload
    },

    setPaginationPage: (
      state: AllTasksTableState,
      { payload }: PayloadAction<number>
    ) => {
      state.pagination.page = payload
    },

    setPaginationSize: (
      state: AllTasksTableState,
      { payload }: PayloadAction<number>
    ) => {
      state.pagination.per_page = payload
    },

    resetPagination: (state: AllTasksTableState) => {
      state.pagination = initialPagination
    },

    setSort: (
      state: AllTasksTableState,
      {
        payload
      }: PayloadAction<{
        normal: string[]
        custom: string[]
        tableSort: TableApiSort[]
      }>
    ) => {
      const { normal, custom, tableSort } = payload
      state.sort = normal
      state.customSort = custom
      state.tableApiSort = tableSort
    },

    toggleSelected: (
      state: AllTasksTableState,
      { payload }: PayloadAction<string>
    ) => {
      if (state.selected.includes(payload)) {
        state.selected = state.selected.filter(id => id !== payload)
        return
      }

      state.selected.push(payload)
    },

    removeMultipleSelected: (
      state: AllTasksTableState,
      { payload }: PayloadAction<string[]>
    ) => {
      state.selected = arrayDifference(state.selected, payload)
    },

    addMultipleSelected: (
      state: AllTasksTableState,
      { payload }: PayloadAction<string[]>
    ) => {
      state.selected = uniqueArray(state.selected.concat(payload))
    },

    clearSelected: (state: AllTasksTableState) => {
      state.selected = []
    }
  }
})

export default allTasksTable.reducer

export const {
  setPagination,
  resetPagination,
  setPaginationPage,
  setPaginationSize,
  setSort,
  toggleSelected,
  removeMultipleSelected,
  addMultipleSelected,
  clearSelected
} = allTasksTable.actions

export const selectAllTasksTable = (state: RootState) => state.allTasksTable
